import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { requestAuth,requestAuthDemo, whatsAppReq } from '../../store/auth/auth.thunks'
import { requestBalance } from '../../store/balance/balance.thunks'
import { requestRecaptcha } from '../../store/recaptcha/recaptcha.thunks'
import { getRecaptchaSuccess } from '../../store/recaptcha/recaptcha.slice'
import { setVersion } from '../../store/version/version.slice'
import { postNumberSignUp, resendOTP, verifyOTP, postCheckPromo, getPromotionsList, registerNew, resetOtp, resetWhatsAppPassword} from '../../store/signUp/signUp.thunks'
import { postNumberForgotPassword, verifyForgotPasswordOTP, resetPassword, getVerifyOtp} from '../../store/forgotPassword/forgotPassword.thunks'
import { setIsDetailedPromo, setIsTermCondition, setPromoInfo } from '../../store/signUp/signUp.slice'
import { setLoginNew, setTab } from '../../store/LoginNew/loginNew.slice'


export const connectLoginPopUp = (wrappedProps) => (component) => {
  function mapStateToProps(state) {
    return {
      auth: state.auth,
      recaptcha: state.recaptcha,
      version: state.version,
      B2C: state.B2C,
      isDetailedPromo: state.signUp.isDetailedPromo,
      isTermCondition: state.signUp.isTermCondition,
      promoInfo: state.signUp.promoInfo,
      tab: state.loginNew.tab,
      promoListStore: state.signUp.promoListStore,
      signUp: state.signUp,
      elementsParams: state.elementsParams,
      logo: state.logo,
    }
  }

  function mapDispatchToProps(dispatch) {
    const actions = {
      requestAuth,
      requestRecaptcha,
      getRecaptchaSuccess,
      setVersion,
      requestBalance,
      postNumberSignUp,
      resendOTP,
      verifyOTP,
      postCheckPromo,
      getPromotionsList,
      setIsDetailedPromo,
      setPromoInfo,
      postNumberForgotPassword,
      verifyForgotPasswordOTP,
      resetPassword,
      getVerifyOtp,
      resetWhatsAppPassword,
      resetOtp,
      setTab,
      setIsTermCondition,
      setLoginNew,
      whatsAppReq,
      // requestAuthGoogle,
      registerNew,
      requestAuthDemo
    }

    return { actions: bindActionCreators(actions, dispatch) }
  }

  return connect(mapStateToProps, mapDispatchToProps)(component)
}
